import React from 'react';
import ReactDOM from 'react-dom';
import jquery from 'jquery';
import Popper from 'popper.js';
//amchart license
import * as am4core from "@amcharts/amcharts4/core";
am4core.addLicense("CH271532638");
window.React = React;
window.ReactDOM = ReactDOM;
window.jQuery = jquery;
window.jquery = jquery;
window.$ = jquery;
window.Popper = Popper;